import { ViewStyle } from "react-native";

export function morphClassNameAsStyle(className: string) {
  return {
    $$css: true,
    display: className,
  } as ViewStyle;
}
